import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';
import SetDescribealbeScoreCommentsFull from './SetDescribealbeScoreCommentsFull';
import { Row,Col } from 'react-bootstrap';

const FinalScoreSave = ({ schoolClassId, schoolClassDegree, courseId, monthInd, isAgent, onChange, onClose}) => {
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [continualTest, setContinualTest] = useState(null);
    const [continualTestId, setContinualTestId] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [describealbeScoreCommentsVisible, setDescribealbeScoreCommentsVisible] = useState(false);
    const [positiveVeryGood, setPositiveVeryGood] = useState("");
    const [negativeVeryGood, setNegativeVeryGood] = useState("");
    const [recommendVeryGood, setRecommendVeryGood] = useState("");
    const [positiveGood, setPositiveGood] = useState("");
    const [negativeGood, setNegativeGood] = useState("");
    const [recommendGood, setRecommendGood] = useState("");
    const [positiveAcceptable, setPositiveAcceptable] = useState("");
    const [negativeAcceptable, setNegativeAcceptable] = useState("");
    const [recommendAcceptable, setRecommendAcceptable] = useState("");
    const [positiveRejected, setPositiveRejected] = useState("");
    const [negativeRejected, setNegativeRejected] = useState("");
    const [recommendRejected, setRecommendRejected] = useState("");
    const [studentIndex, setStudentIndex] = useState(-1);
    const [studentName, setStudentName] = useState("");

    useEffect(() => {
      var k = parseInt(monthInd);
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, courseId:courseId, monthInd:k, isAgent:isAgent};
      var url = config.Server+`/school/teacher/continual-test/final/get`;

      setLoading(true);
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  var ct = response.data;
                  setContinualTestId(ct.continualTestId)
                  for(var i=0;i<ct.students.length;i++){
                    ct.students[i]["scoreStr"] = String(ct.students[i].score);
                  }
                  console.log(ct.students)
                  for(var i=0;i<ct.students.length;i++){
                    for(var j=0;j<ct.students[i].otherScores.length;j++){
                        if(!ct.students[i].isValidOtherScores[j])ct.students[i].otherScores[j] = "";
                    }
                  }
                    ct.students.sort((a, b) => {
                        const fn = a.student.lastname.localeCompare(b.student.lastname, 'fa');
                        if (fn !== 0) return fn;
                        return a.student.firstname.localeCompare(b.student.firstname, 'fa');
                    });
                   console.log("students after sort is> ", ct.students);
                  setContinualTest(ct);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={saving} />
        )
    }
    const saveItem = function(){
      setSaving(true);
      var tmp = continualTest.students;
      var students = [];
      for(var i=0;i<tmp.length;i++){
        var hasScore = true;
        if(tmp[i].scoreStr == null) tmp[i].scoreStr = "";
        if(tmp[i].scoreStr == "") hasScore = false;
        if(!util.IsNumber(tmp[i].scoreStr)) hasScore = false;

        var isPresent = true;
        var isRegistered = true;
        var score = 0;
        if(hasScore) {
            if(parseFloat(tmp[i].scoreStr)>20){
                setErrorMessage("نمره نمی تواند بیشتر از 20 باشد");
                setErorVisible(true);
                setSaving(false);
                return;
            }
            score = parseFloat(tmp[i].scoreStr);
        }
        students.push({
            studentId:tmp[i].student.id, 
            isRegistered:isRegistered, 
            isPresent:isPresent, 
            score:score,
            positiveCommentVeryGood:tmp[i].positiveCommentVeryGood,
            negativeCommentVeryGood:tmp[i].negativeCommentVeryGood,
            recommendationVeryGood:tmp[i].recommendationVeryGood,
            positiveCommentGood:tmp[i].positiveCommentGood,
            negativeCommentGood:tmp[i].negativeCommentGood,
            recommendationGood:tmp[i].recommendationGood,
            positiveCommentAcceptable:tmp[i].positiveCommentAcceptable,
            negativeCommentAcceptable:tmp[i].negativeCommentAcceptable,
            recommendationAcceptable:tmp[i].recommendationAcceptable,
            positiveCommentRejected:tmp[i].positiveCommentRejected,
            negativeCommentRejected:tmp[i].negativeCommentRejected,
            recommendationRejected:tmp[i].recommendationRejected,
        });
      }
      var url = config.Server+`/school/teacher/continual-test/save`;
      var params = {login:util.getTrustedUser(), id:continualTestId, courseId:courseId, schoolClassId:schoolClassId, testDate:continualTest.testDate, monthInd:continualTest.monthInd, isAgent:isAgent, isFinal:true, students:students, comment:"نمره نهائی"};
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {

              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  onChange(schoolClassId, courseId);

                  onClose();  

                  setSaving(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
                console.log(error);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const onInputChange = function(e, index){
        var tmp = {...continualTest};
        var val = '';
        val = (e.target && e.target.value) || '';
        var v = val;
        if(v == null) v = "";
        tmp.students[index].scoreStr = v;
        setContinualTest(tmp);
    }
    const onCheckboxChange = (e, name, index) => {
        var tmp = {...continualTest};
        if(name == "isPresent"){
            tmp.students[index].isPresent = e.checked;
        }
        setContinualTest(tmp);
    }
    const onScoreCheckboxChange = (e, score, index) => {
        var tmp = {...continualTest};
        tmp.students[index].scoreStr = String(score);
        tmp.students[index].score = score;
        setContinualTest(tmp);
    }
    const getCheckedState = function (index, target){
        var score = continualTest.students[index].score;
        if(target == 1){
            if(score>util.describableScores.good)return true;
            else return false;
        }
        else if(target == 2){
            if((score>util.describableScores.acceptable)&&(score<=util.describableScores.good)) return true;
            else return false;
        }
        else if(target == 3){
            if((score>=10)&&(score<=util.describableScores.acceptable)) return true;
            else return false;
        }
        else if(target == 4){
            if(score<10) return true;
            else return false;
        }

        return false;
    }
    const onSetDescribleableScoreComments = function(index
        , positiveVeryGoodStr, negativeVeryGoodStr, recommendVeryGoodStr
        , positiveGoodStr, negativeGoodStr, recommendGoodStr
        , positiveAcceptableStr, negativeAcceptableStr, recommendAcceptableStr
        , positiveRejectedStr, negativeRejectedStr, recommendRejectedStr
    ){
        var tmp = {...continualTest};
        console.log("positiveVeryGoodStr is> ", positiveVeryGoodStr);
        console.log("negativeVeryGoodStr is> ", negativeVeryGoodStr);
        console.log("recommendVeryGoodStr is> ", recommendVeryGoodStr);

        console.log("positiveGoodStr is> ", positiveGoodStr);
        console.log("negativeGoodStr is> ", negativeGoodStr);
        console.log("recommendGoodStr is> ", recommendGoodStr);

        console.log("positiveAcceptableStr is> ", positiveAcceptableStr);
        console.log("negativeAcceptableStr is> ", negativeAcceptableStr);
        console.log("recommendAcceptableStr is> ", recommendAcceptableStr);

        console.log("positiveRejectedStr is> ", positiveRejectedStr);
        console.log("negativeRejectedStr is> ", negativeRejectedStr);
        console.log("recommendRejectedStr is> ", recommendRejectedStr);
        tmp.students[index].positiveCommentVeryGood = positiveVeryGoodStr;
        tmp.students[index].negativeCommentVeryGood = negativeVeryGoodStr;
        tmp.students[index].recommendationVeryGood = recommendVeryGoodStr;
        tmp.students[index].positiveCommentGood = positiveGoodStr;
        tmp.students[index].negativeCommentGood = negativeGoodStr;
        tmp.students[index].recommendationGood = recommendGoodStr;
        tmp.students[index].positiveCommentAcceptable = positiveAcceptableStr;
        tmp.students[index].negativeCommentAcceptable = negativeAcceptableStr;
        tmp.students[index].recommendationAcceptable = recommendAcceptableStr;
        tmp.students[index].positiveCommentRejected = positiveRejectedStr;
        tmp.students[index].negativeCommentRejected = negativeRejectedStr;
        tmp.students[index].recommendationRejected = recommendRejectedStr;
        console.log(tmp)
        setContinualTest(tmp);
        setDescribealbeScoreCommentsVisible(false);
    }
    const showSetDescribleableScoreCommentsForm = function(index){
        var row = continualTest.students[index];
        setPositiveVeryGood(row.positiveCommentVeryGood.trim());
        setNegativeVeryGood(row.negativeCommentVeryGood.trim());
        setRecommendVeryGood(row.recommendationVeryGood.trim());
        setPositiveGood(row.positiveCommentGood.trim());
        setNegativeGood(row.negativeCommentGood.trim());
        setRecommendGood(row.recommendationGood.trim());
        setPositiveAcceptable(row.positiveCommentAcceptable.trim());
        setNegativeAcceptable(row.negativeCommentAcceptable.trim());
        setRecommendAcceptable(row.recommendationAcceptable.trim());
        setPositiveRejected(row.positiveCommentRejected.trim());
        setNegativeRejected(row.negativeCommentRejected.trim());
        setRecommendRejected(row.recommendationRejected.trim());
        setStudentIndex(index);
        setStudentName("[" + row.student.nationalId + "] " + row.student.firstname + " " + row.student.lastname);
        setDescribealbeScoreCommentsVisible(true);

    }
    const createScoreGetter = function(index){
        if((schoolClassDegree >=1) && (schoolClassDegree <=6)){
            var row = continualTest.students[index];
            var color = "#ee4444";
            if((row.positiveCommentVeryGood.trim() != "")||(row.negativeCommentVeryGood.trim() != "")||(row.recommendationVeryGood.trim() != "")||
                (row.positiveCommentGood.trim() != "")||(row.negativeCommentGood.trim() != "")||(row.recommendationGood.trim() != "")||
                (row.positiveCommentAcceptable.trim() != "")||(row.negativeCommentAcceptable.trim() != "")||(row.recommendationAcceptable.trim() != "")||
                (row.positiveCommentRejected.trim() != "")||(row.negativeCommentRejected.trim() != "")||(row.recommendationRejected.trim() != "")
                )color = "#44ee44";
            return(
                <>
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.veryGood, index)}} checked={getCheckedState(index, 1)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.good, index)}} checked={getCheckedState(index, 2)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.acceptable, index)}} checked={getCheckedState(index, 3)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.rejected, index)}} checked={getCheckedState(index, 4)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <div onClick={()=>{showSetDescribleableScoreCommentsForm(index)}} style={{width:"20px", height:"20px", backgroundColor:color, borderRadius:"50%"}}></div>
                    </td>                
                </>
            )

        }
        else{
            return(
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <InputText keyfilter={"num"} value={continualTest.students[index].scoreStr} onChange={(e) => onInputChange(e, index)} maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}}/>
                </td>                
            )
        }
    }
    return (
        <>
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نمره نهائی" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>نمره نهائی</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>کلاس: {continualTest.schoolClass.name}</td>
                            </tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>ماه ثبتی: {util.getMonthName(monthInd)}</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>درس: {continualTest.course.name}</td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>
                    <Row>
                        <Col md={12} style={{backgroundColor:"#44aa44", color:"#ffffffff", margin:"0px 10px 10px 0px", width:"calc(100% - 20px)", padding:"5px"}}>
                            نمره &nbsp;&nbsp; 0 &nbsp;&nbsp; بعنوان عدم وجود نمره در نظر گرفته می شود و در معدل تاثیری ندارد
                        </Col>
                    </Row>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr style={{height:"100px"}}>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{width:"100px", backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                {
                                    continualTest.testDates.map((date, index)=>{
                                        return(
                                            <th style={{width:"45px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                                <div style={{transform:"rotate(270deg)", position:"absolute", top:"35px", left:"-15px"}}>{util.SeperateDate(date)}</div>
                                                
                                            </th>
                                        )
                                    })
                                }
                                {
                                    ((schoolClassDegree >=1) && (schoolClassDegree <=6))?
                                    <>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>خیلی خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>قابل قبول</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"25px", left:"-45px", width:"120px", textAlign:"left"}}>نیاز به تلاش</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>نظر</div>                                    
                                    </th>
                                    </>
                                    :
                                    <th style={{minWidth:"70px", width:((schoolClassDegree >=1) && (schoolClassDegree <=6))? "180px" :"90px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                        نمره
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                continualTest.students.map((row, index)=>{
                                    return(
                                    <tr>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        {
                                            row.otherScores.map((sc, index2)=>{
                                                return(
                                                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                        {
                                                            ((schoolClassDegree <1) || (schoolClassDegree >6))?sc
                                                            :sc==util.describableScores.veryGood? "خ خ"
                                                            :sc==util.describableScores.good? "خ"
                                                            :sc==util.describableScores.acceptable? "ق ق"
                                                            :sc==util.describableScores.rejected? "ن ت"
                                                            :<></>
                                                        }
                                                    </td>
                                                )
                                            })
                                        }
                                        {createScoreGetter(index)}
                                    </tr>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>
            {
            describealbeScoreCommentsVisible?
            <SetDescribealbeScoreCommentsFull 
            onAccept={(index
                    , positiveVeryGoodStr, negativeVeryGoodStr, recommendVeryGoodStr
                    , positiveGoodStr, negativeGoodStr, recommendGoodStr
                    , positiveAcceptableStr, negativeAcceptableStr, recommendAcceptableStr
                    , positiveRejectedStr, negativeRejectedStr, recommendRejectedStr
                )=>
                    {onSetDescribleableScoreComments(index
                        , positiveVeryGoodStr, negativeVeryGoodStr, recommendVeryGoodStr
                        , positiveGoodStr, negativeGoodStr, recommendGoodStr
                        , positiveAcceptableStr, negativeAcceptableStr, recommendAcceptableStr
                        , positiveRejectedStr, negativeRejectedStr, recommendRejectedStr
                    )}} 
            index={studentIndex} studentName={studentName} 
            positiveCommentVeryGood={positiveVeryGood} negativeCommentVeryGood={negativeVeryGood} recommendationVeryGood={recommendVeryGood} 
            positiveCommentGood={positiveGood} negativeCommentGood={negativeGood} recommendationGood={recommendGood} 
            positiveCommentAcceptable={positiveAcceptable} negativeCommentAcceptable={negativeAcceptable} recommendationAcceptable={recommendAcceptable} 
            positiveCommentRejected={positiveRejected} negativeCommentRejected={negativeRejected} recommendationRejected={recommendRejected} 
            onClose={()=>{setDescribealbeScoreCommentsVisible(false)}} 
            />
            :
            <></>
            }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
            </>
    )
};

export default FinalScoreSave;